(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'Administration'];

    function HomeController ($scope, Principal, LoginService, $state, Administration) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.userRegistrationEnabled = false;

        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
            Administration.get({}, function(result) {
                vm.userRegistrationEnabled = result.userRegistrationEnabled;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();
